import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { JetbrainsAiProviderForm } from '@modules/ai/common/forms';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { GeneralProviderFormWrapper, ProviderControlVariant } from '../common/general-provider-form-wrapper';
export function JetbrainsAiConfiguration(props) {
    const { provider, className, form } = props;
    const { fieldState } = useController({ name: `provider.jetbrains`, control: form.control });
    return (_jsx(GeneralProviderFormWrapper, { defaultProviderControl: ProviderControlVariant.radio, label: "JetBrains AI", withTestConnection: true, className: className, fieldState: fieldState, ...props, ...assignTestId(provider.id), children: _jsx(JetbrainsAiProviderForm, { form: form }) }));
}
